/**
 * Shared scroll-reveal helpers. Reads --r3nu-reveal-threshold from theme settings.
 * Mobile uses a looser intersection root so elements animate in sooner on short viewports.
 */
(function () {
  var MOBILE_MQ = '(max-width: 749px)';

  function getThreshold() {
    var v = parseFloat(
      getComputedStyle(document.documentElement).getPropertyValue('--r3nu-reveal-threshold')
    );
    return isNaN(v) || v <= 0 ? 0.2 : v;
  }

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  /** Positive bottom margin extends the IO root downward → earlier trigger while scrolling. */
  function getRootMargin() {
    var threshold = getThreshold();
    var pct = Math.round(threshold * 100);
    if (isMobile()) {
      pct = Math.min(35, Math.max(pct, 12));
    } else {
      pct = Math.max(pct, 5);
    }
    return '0px 0px ' + pct + '% 0px';
  }

  function visibleHeightRatio(elOrRect) {
    var r =
      elOrRect && elOrRect.getBoundingClientRect
        ? elOrRect.getBoundingClientRect()
        : elOrRect.boundingClientRect || elOrRect;
    var vh = window.innerHeight || 1;
    var visibleTop = Math.max(0, r.top);
    var visibleBottom = Math.min(vh, r.bottom);
    var visibleHeight = Math.max(0, visibleBottom - visibleTop);
    var h = Math.max(1, r.height);
    return visibleHeight / h;
  }

  /**
   * Tall-section-safe reveal check. When the element is taller than the viewport,
   * required visible fraction is capped so a peek is enough (honours theme threshold).
   */
  function shouldReveal(el, entry) {
    if (!el || !el.getBoundingClientRect) return false;
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || 1;
    if (r.bottom <= 0 || r.top >= vh) return false;

    var threshold = getThreshold();
    var h = Math.max(1, r.height);
    var frac = visibleHeightRatio(r);
    var need = Math.min(threshold, (vh / h) * 0.98);

    if (frac >= need) return true;
    if (entry && entry.intersectionRatio >= Math.min(threshold, need)) return true;

    if (isMobile()) {
      var visibleH = Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0));
      var minPx = Math.max(32, Math.round(vh * threshold * 0.5));
      if (visibleH >= minPx) return true;
    }

    return false;
  }

  function buildThresholdList() {
    var list = [];
    var i;
    for (i = 0; i <= 100; i += 1) {
      list.push(i / 100);
    }
    return list;
  }

  window.R3NU = window.R3NU || {};
  window.R3NU.reveal = {
    getThreshold: getThreshold,
    isMobile: isMobile,
    getRootMargin: getRootMargin,
    visibleHeightRatio: visibleHeightRatio,
    shouldReveal: shouldReveal,
    buildThresholdList: buildThresholdList,
  };
})();
